// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-wrapper[data-v-0e7932ab] .card {\n  display: flex !important;\n  margin-bottom: 0;\n}\n.bg-color[data-v-0e7932ab] {\n  background-color: white !important;\n}\n@media (min-width: 768px) {\n.courses-list[data-v-0e7932ab] {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n}\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
